// import { Button} from "@mui/material";
import { useParams } from "@reach/router";
import { useProject } from "../../hooks/useProject";
import { useTeam } from "../../hooks/useTeam";

import { api } from "../../util/api";
import { enqueueSnackbar } from "notistack";
import { useChainlinkDesigns } from "../../hooks/useChainlinkDesigns";

import * as React from "react";

export const ChainlinkDesignPicker = () => {
  const { projectId } = useParams();
  const { chainlinkDesigns, isLoading, error } = useChainlinkDesigns();
  const { project, mutate } = useProject(projectId);
  const { teamIsLoading, team } = useTeam();

  if (isLoading || teamIsLoading) {
    return <div className="spinner" />;
  }

  if (error) {
    console.log(error);
    return <p>Something went wrong</p>;
  }

  if (chainlinkDesigns.length === 0) {
    return (
      <div>
        <h1 className="text-xl font-bold mb-4">No Chain Link Designs</h1>
        <h1 className="text-xl font-bold mb-4">
          Please
          {!team.permissions.includes("createDesign") ? " have an owner " : " "}
          create a chain link design
        </h1>
      </div>
    );
  }

  const saveDesignToProject = async (chainlinkDesignId) => {
    enqueueSnackbar("Changing Project Chain Link Design");

    await mutate(api("PUT", `/project/${project.id}`, { chainlinkDesignId }), {
      optimisticData: { ...project, chainlinkDesignId: chainlinkDesignId },
      revalidate: false,
    });
    enqueueSnackbar("Changed Chain Link Design", { variant: "success" });
  };

  return (
    <div>
      <div>
        <div>
          <label
            htmlFor="chainlinkFilterType"
            className="block text-sm font-medium text-gray-700"
          >
            Choose a Chain Link Design:
          </label>
          <select
            id="chainlinkFilterType"
            value={project.chainlinkDesignId || ""} // Default to empty string if no design is selected
            onChange={(e) => {
              saveDesignToProject(e.target.value);
            }}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 rounded-md"
            disabled={!team.permissions.includes("editProject")}
          >
            {/* Placeholder option */}
            <option value="" disabled>
              Select a Chain Link Design
            </option>
            {chainlinkDesigns
              ?.sort((a, b) => (a.name < b.name ? -1 : 1))
              .map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
          </select>
        </div>
      </div>
    </div>
  );
};
